import { ToastContainer } from 'react-toastify';
import { useIsMobile } from '@hooks/useIsMobile';

/**
 * Toast positioning: `top-right` on desktop matches the standard SaaS
 * pattern; `top-center` below md (768px) is more reachable on phones where
 * the right edge of the screen overlaps a one-hand thumb's reach zone.
 *
 * Wrapped in its own component so `useIsMobile` (MUI useMediaQuery) lives
 * inside React's render path. Mount once at the app root.
 */
export function ResponsiveToastContainer() {
  const isMobile = useIsMobile();
  return (
    <ToastContainer
      position={isMobile ? 'top-center' : 'top-right'}
      autoClose={3000}
    />
  );
}
